import {type PartialOptions, UI} from "stem-core/ui/UIBase";
import {registerStyle, styleRule} from "stem-core/ui/Style";
import {Modal, ModalStyle} from "../../../../blinkpay/ui/Modal.jsx";
import {EditableCard} from "../../ui/EditableCard.jsx";
import {apiUpdateLegalEntity, LegalEntity} from "../../../../client/state/LegalEntityStore.js";
import {autoredraw} from "../../../../stem-core/decorators/AutoRedraw";

class LegalEntityModalStyle extends ModalStyle {
    @styleRule
    editableCard = {
        ">:first-child>:first-child": {
            boxShadow: "none",
            backgroundColor: "inherit",
        }
    }
}

interface LegalEntityModalOptions {
    legalEntity?: LegalEntity;
}

@registerStyle(LegalEntityModalStyle)
@autoredraw(LegalEntity)
export class LegalEntityModal extends Modal<LegalEntityModalOptions> {
    getDefaultOptions(): PartialOptions<LegalEntityModal> {
        return {
            ...super.getDefaultOptions(),
            legalEntity: null,
        };
    }

    render() {
        const {legalEntity} = this.options;

        return <EditableCard className={this.styleSheet.editableCard}
                             values={legalEntity}
                             editableFields={["name", "legalName", "legalEntityType", "isNonprofit", "taxId", "ownerId",
                                 "streetAddress", "stateAddress", "cardStatementName", "bankAccountLastDigits"]}
                             onUpdate={(data) => apiUpdateLegalEntity({legalEntityId: legalEntity.id, ...data})}
        />
    }
}
